import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "jumbotron"
}
const _hoisted_3 = { class: "display-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "lead"
}
const _hoisted_7 = {
  key: 1,
  class: "lead"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 1,
  class: "row"
}
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "input-group mb-3" }
const _hoisted_18 = { class: "input-group-append" }
const _hoisted_19 = { style: {"text-align":"center"} }
const _hoisted_20 = ["href"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 1,
  class: "jumbotron"
}

import { ref, computed, watch, onMounted } from 'vue'
    import { useId } from '@common/composables'
    import { useAccessSharePage } from '@DataSharing/Shares/pages-core'
    import ValidationError from "@common/Components/ValidationError.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AccessSharePage',
  setup(__props) {

    document.title = 'Access TransparentChoice'

    const id = useId()
    const email = ref()

    const { useAccessShareQuery, useSendEmailConfirmationCommand } = useAccessSharePage()
    
    const { modelAccessShareQueryV1, runAccessShareQueryV1 } = useAccessShareQuery(id)
    const { invokeSendEmailConfirmationCommandV1, succeedSendEmailConfirmationCommandV1, validationErrors } = useSendEmailConfirmationCommand(id, email)

    const isEmailAuthorized = computed(() => modelAccessShareQueryV1.value?.IsEmailAuthorized)
    const isAuthenticatedUser = computed(() => modelAccessShareQueryV1.value?.IsAuthenticatedUser)
    const organizationName = computed(() => modelAccessShareQueryV1.value?.OrganizationUnitName)
    const organizationUnitId = computed(() => modelAccessShareQueryV1.value?.OrganizationUnitId)
    const workspaceName = computed(() => modelAccessShareQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelAccessShareQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelAccessShareQueryV1.value?.ResourceName)
    const isAccessable = computed(() => modelAccessShareQueryV1.value?.IsAccessable)
    const accessUrl = computed(() => modelAccessShareQueryV1.value?.AccessUrl)
    const accessIssueDetails = computed(() => modelAccessShareQueryV1.value?.AccessIssueDetails)

    runAccessShareQueryV1()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    (isAccessable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, [
            (isEmailAuthorized.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Congratulations!"))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "Welcome!"))
          ]),
          (isEmailAuthorized.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _cache[2] || (_cache[2] = _createTextVNode("We confirmed your access to ", -1 /* CACHED */)),
                _createElementVNode("strong", null, _toDisplayString(resourceName.value), 1 /* TEXT */),
                _cache[3] || (_cache[3] = _createTextVNode(" owned by ", -1 /* CACHED */)),
                _createElementVNode("strong", null, _toDisplayString(organizationName.value), 1 /* TEXT */),
                _cache[4] || (_cache[4] = _createTextVNode(" data in TransparentChoice application", -1 /* CACHED */))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _cache[5] || (_cache[5] = _createTextVNode("You are about to access ", -1 /* CACHED */)),
                _createElementVNode("strong", null, _toDisplayString(resourceName.value), 1 /* TEXT */),
                _cache[6] || (_cache[6] = _createTextVNode(" owned by ", -1 /* CACHED */)),
                _createElementVNode("strong", null, _toDisplayString(organizationName.value), 1 /* TEXT */),
                _cache[7] || (_cache[7] = _createTextVNode(" data in TransparentChoice application", -1 /* CACHED */))
              ])),
          _cache[14] || (_cache[14] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          (isEmailAuthorized.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (!isAuthenticatedUser.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("a", {
                          href: accessUrl.value,
                          class: "btn btn-lg btn-success"
                        }, "Go to " + _toDisplayString(resourceName.value), 9 /* TEXT, PROPS */, _hoisted_11)
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-6" }, [
                        _createCommentVNode("<div>\n                            <h5>Skip email confirmation in the future and ...</h5>\n                            <ul>\n                                <li>forgot about links</li>\n                                <li>access your dashboard</li>\n                                <li>all data in one place</li>\n                                <li>login with password</li>\n                                <li>fast and secure</li>\n                            </ul>\n                            <a :href=\"`/#/organizations/users/requestaccount/${organizationUnitId}`\" target=\"_blank\">Request an account</a>\n                        </div>")
                      ], -1 /* CACHED */))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("a", {
                          href: accessUrl.value,
                          class: "btn btn-lg btn-success",
                          style: {"margin":"20px"}
                        }, "Go to " + _toDisplayString(resourceName.value), 9 /* TEXT, PROPS */, _hoisted_14)
                      ])
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (!_unref(succeedSendEmailConfirmationCommandV1))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[10] || (_cache[10] = _createElementVNode("p", null, "We have to confirm your email for security reasons before you will be able to access it", -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                          type: "email",
                          class: "form-control form-control-lg",
                          placeholder: "Your email"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, email.value]
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(invokeSendEmailConfirmationCommandV1) && _unref(invokeSendEmailConfirmationCommandV1)(...args))),
                            class: "btn btn-primary",
                            type: "button"
                          }, "Confirm")
                        ])
                      ]),
                      _createVNode(ValidationError, {
                        context: "Email",
                        errors: _unref(validationErrors)
                      }, null, 8 /* PROPS */, ["errors"]),
                      _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                      _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[9] || (_cache[9] = _createElementVNode("h5", null, "or", -1 /* CACHED */)),
                        _createElementVNode("a", {
                          href: `/#/signin?returnUrl=${encodeURIComponent(accessUrl.value)}`,
                          class: "btn btn-secondary"
                        }, " Sign in with TransparentChoice account ", 8 /* PROPS */, _hoisted_20)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("p", null, "We send confirmation email on your maiblox. Please follow the link from that email to continue...", -1 /* CACHED */)
                    ]))]))
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _cache[15] || (_cache[15] = _createElementVNode("h1", { class: "display-4" }, "Access denied", -1 /* CACHED */)),
          _createElementVNode("p", null, _toDisplayString(accessIssueDetails.value), 1 /* TEXT */),
          _cache[16] || (_cache[16] = _createElementVNode("hr", null, null, -1 /* CACHED */))
        ]))
  ]))
}
}

})